import * as angular from "angular";
import {IController, IFilterService} from "angular";
import * as _ from "lodash";
import {AgentDialogService} from "../../services/agent-dialogs-service.service";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentsAlerts} from "../../services/agents-alerts.service";
import {AgentsService} from "../../services/agents-service.service";
import {AgentModel} from "../../angular/models/agent.model";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {$agentFactory} from "../../$agent.factory";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {AgentAuthType} from "../../types/agentAuth.type";
import {AgentType} from "../../types/agent.type";
import {AgentClientType} from "../../types/agentClient.type";
import {GroupModel} from "../../../groups/models/group.model";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {TagType} from "../../../tags/angular/types/tag.type";
import {ExportType} from "../../../commons/types/export.type";
import {EXPORT_CSV_SIZE_LIMIT, EXPORT_EXCEL_SIZE_LIMIT} from "../../../commons/angular/constants/commons";
import {BulkPreferencesUpdateQuery} from "../../models/queries.model";

export class AgentsListViewCtrl implements IController {

  selectedQuickFilterId?: string;
  serviceAreaIds: string[];
  tags: string[];
  branchIds: string[];
  groupIds: string[];
  groupsBranchIds: string[];
  isActive: boolean;
  sessionRecording: boolean;
  termsApproved?: boolean;
  agentSkills: string[];
  noArea?: boolean;
  noBranches?: boolean;
  gpsStatus: boolean;
  viewTableSettings?: ViewSettingsModel;
  gpsPermissions: string[];
  agentType: AgentType;
  agentIds: string[];
  teamIds?: string[];

  public isSmallScreen: boolean;

  public pageName: string;
  private status: any;
  private agentTypes: any;
  private totalsLoading: false;
  private doReload: any;
  private totals: any;
  private filtersConfig: any;
  private siteId: any;
  private selectedAgentIds: any;
  private excludeMode: boolean;
  private agentsPreferences: any;
  public filterAgentsByGpsEnabled: boolean;

  public agentAuthType: typeof AgentAuthType = AgentAuthType;

  constructor(private $log, private agentRequests: AgentRequests, private agentStatus,
              private quickFilterContextService: QuickFilterContextService,
              private $stateParams, private $state, private confirmDialogService: ConfirmDialogService, private agentConstants,
              private IAMPermissions, private agentDialogService: AgentDialogService, private viewSettingsService: ViewSettingsService,
              private agentsAlerts: AgentsAlerts, private agentsService: AgentsService,
              private splitService: SplitService, private bringozLoaderService: BringozLoaderService, private analyticsService: AnalyticsService,
              private $agent: $agentFactory, private $filter: IFilterService, private siteContextService: SiteContextService,
              private $mdMedia, private viewFilterSettingsService: ViewFilterSettingsService, private $groups) {
    this.pageName = this.$state.current.name;
  }

  $onInit() {
    this.isSmallScreen = !this.$mdMedia('gt-sm');
    this.filterAgentsByGpsEnabled = this.siteContextService.getSiteInfo().filterAgentsByGpsEnabled;

    this.agentTypes = this.agentConstants.types;
    this.siteId = this.splitService.getSiteId();
    this.filtersConfig = {
      queryString: undefined,
      agentsStatus: undefined,
      includeFilters: [
        SiteFiltersType.agentSkills,
        SiteFiltersType.tags,
        SiteFiltersType.branchIds,
        SiteFiltersType.noBranches,
        SiteFiltersType.groupIds,
        SiteFiltersType.serviceAreaIds,
        SiteFiltersType.isActive,
        SiteFiltersType.sessionRecording,
        SiteFiltersType.termsApproved,
        SiteFiltersType.agentType,
        SiteFiltersType.teamIds,
        SiteFiltersType.agentIds
      ],
      bringozFilters: {
        [SiteFiltersType.branchIds]: this.branchIds || [],
        [SiteFiltersType.noBranches]: this.noBranches,
        [SiteFiltersType.groupIds]: this.groupIds || [],
        [SiteFiltersType.serviceAreaIds]: this.serviceAreaIds || [],
        [SiteFiltersType.tags]: this.tags || [],
        [SiteFiltersType.agentSkills]: this.agentSkills || undefined,
        [SiteFiltersType.isActive]: this.isActive || true,
        [SiteFiltersType.sessionRecording]: this.sessionRecording,
        [SiteFiltersType.termsApproved]: this.termsApproved,
        [SiteFiltersType.noArea]: this.noArea,
        [SiteFiltersType.agentType]: this.agentType,
        [SiteFiltersType.teamIds]: this.teamIds || [],
        [SiteFiltersType.agentIds]: this.agentIds || []
      },
      excludeIdsMap: {
        [SiteFiltersType.branchIds]: this.groupsBranchIds || []
      },
      queryMap: {
        tagType: [TagType.Agent, TagType.Account]
      },
      settings: this.splitService.getSiteAgentsSettings(this.splitService.getSiteId())
    }

    if (this.viewTableSettings?.settings) {
      const settingsCopy = angular.copy(this.filtersConfig.settings.columns);
      _.forOwn(settingsCopy, (value: { enabled?: boolean, order?: number, permission?: string }, key: string) => {
        this.filtersConfig.settings.columns[key].enabled = (this.viewTableSettings.settings[key] === 1) || value.enabled;
      })
    }

    if (this.filterAgentsByGpsEnabled) {
      this.filtersConfig.includeFilters = this.filtersConfig.includeFilters.concat([SiteFiltersType.gpsPermissions, SiteFiltersType.gpsStatus]);
      this.filtersConfig.bringozFilters[SiteFiltersType.gpsPermissions] = this.gpsPermissions || [];
      this.filtersConfig.bringozFilters[SiteFiltersType.gpsStatus] = this.gpsStatus;
    }

    this.selectedAgentIds = [];
    this.excludeMode = false;
    this.agentsPreferences = undefined;
    this.totalsLoading = false;
    this.totals = {
      onDuty: 0,
      onDutyOnBreak: 0,
      offDuty: 0,
      total: 0
    };

    this.filtersConfig.agentsStatus = this._getDefaultStatus();
    this.reloadTotals();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      if (quickFilter.settings.groupIds?.length) {
        this.$groups().$asyncValues(quickFilter.settings.groupIds)
          .then((groups) => {
            let groupsBranchIds = [];
            groups.forEach((g: GroupModel) => {
              if (g.branchIds?.length) {
                groupsBranchIds = groupsBranchIds.concat(g.branchIds)
              }
            });
            this.filtersConfig.excludeIdsMap[SiteFiltersType.branchIds] = groupsBranchIds;
            quickFilter.settings[SiteFiltersType.branchIds] = _.uniq(groupsBranchIds);
            this.onFiltersChange(quickFilter.settings, quickFilter);
          })
      } else {
        this.onFiltersChange(quickFilter.settings, quickFilter);
      }
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.filtersConfig.bringozFilters = filters;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;

    // this.reloadTotals();

    this._setStateParams();
  }

  onViewSettingsChange(settings) {
    if ((this.filtersConfig.settings.columns.deviceType.enabled !== settings.columns.deviceType.enabled) && settings.columns.deviceType.enabled) {
      this.doReload = true;
    }
    this.filtersConfig.settings = settings;
    this.splitService.setSiteAgentsSettings(settings);

    this._updateViewTableSettings(settings.columns);
  }

  changeStatus(status) {
    this.filtersConfig.agentsStatus = status;
    this.selectedAgentIds = [];
    this.excludeMode = false;


    const agentType = this.filtersConfig.bringozFilters.agentType;
    const agentSkills = this.filtersConfig.bringozFilters.agentSkills;
    this.$state.go('.', {status: status, agentTypes: agentType, agentSkills: agentSkills}, {
      notify: false,
      reload: false
    });
    this.analyticsService.trackEvent('Agents Filter', 'Status', status || 'All');
  }

  submitQuery(queryString) {
    this.filtersConfig.queryString = queryString;
  }

  onExport(event, exportType: ExportType) {
    const totalGroup = this.filtersConfig.agentsStatus ? this.filtersConfig.agentsStatus.toLowerCase() : 'total';
    const matchedKey = Object.keys(this.totals).find(
      key => key.toLowerCase() === totalGroup.toLowerCase()
    );

    const text = 'Are you sure you want to export?';
    let extraText;

    if (exportType === ExportType.Excel) {
      if (this.totals[matchedKey] > EXPORT_EXCEL_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export', text, extraText, {x: EXPORT_EXCEL_SIZE_LIMIT}, event)
        .then(() => {
          this._export(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    } else if (ExportType.CSV) {
      if (this.totals[matchedKey] > EXPORT_CSV_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export', text, extraText, {x: EXPORT_CSV_SIZE_LIMIT}, event)
        .then(() => {
          this._export(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    }
  }

  reloadTotals() {
    const query = {
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentTypes: this.filtersConfig.bringozFilters.agentType,
      skill: this.filtersConfig.bringozFilters.agentSkills,
      noArea: this.filtersConfig.bringozFilters.noArea,
      noBranches: this.filtersConfig.bringozFilters.noBranches,
      areaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      active: this.filtersConfig.bringozFilters.isActive,
      tags: this.filtersConfig.bringozFilters.tags,
      sessionRecording: this.filtersConfig.bringozFilters.sessionRecording,
      termsApproved: this.filtersConfig.bringozFilters.termsApproved,
      gpsStatus: this.filtersConfig.bringozFilters.gpsStatus,
      gpsPermission: this.filtersConfig.bringozFilters.gpsPermissions,
      ids: this.filtersConfig.bringozFilters.agentIds,
      teamIds: this.filtersConfig.bringozFilters.teamIds
    };

    this.agentRequests.getAgentTotals(query)
      .then((totals) => {
        this.totals = totals;
      })
      .catch((error) => {
        this.$log.error('Failed to get totals, teamDrivers@reloadTotals', error)
      })
  }

  onCreateAgent(event) {
    this.agentDialogService.createAgent(event)
      .then((createdAgent) => {
        this.$state.go('agent.agent-profile', _.assign({}, this.$stateParams, {
          id: createdAgent.id,
          createdAgent: createdAgent
        }));
      })
  }

  onDeleteAgent(agent, $event) {
    let loading = false;
    const text = 'Are you sure you want to delete this driver?';
    this.confirmDialogService.confirmMask('Delete Driver', text, $event)
      .then((shouldMask) => {
        loading = true;
        this.bringozLoaderService.on();
        return this.agentRequests.deleteAgent(agent.id, shouldMask)
      })
      .then((response) => {
        this.doReload = true;
        this.agentsAlerts.deleteOneSuccess(agent);
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.deleteOneError();
          this.$log.error('Failed to delete agent @agentsListView@onDeleteAgent', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }

  onReload() {
    this.doReload = undefined;
  }

  onToggleBulkEdit() {
    const isEnabled = !_.isUndefined(this.agentsPreferences);
    this._setAgentsPreferences(!isEnabled);
  }

  onChangeSelectedAgents(agentIds, excludeMode) {
    this.selectedAgentIds = agentIds;
    this.excludeMode = excludeMode;
  }

  onCancelPreferencesChanges() {
    this.agentsPreferences = undefined;
  }

  onClearSelectedIds() {
    this.selectedAgentIds = [];
    this.excludeMode = false;
  }

  onToggleAll() {
    this.selectedAgentIds = [];
    this.excludeMode = !this.excludeMode;
  }

  getSelectedAgentsCount() {
    return this.excludeMode ? this.getAgentCountBySelectedStatus() - this.selectedAgentIds.length : this.selectedAgentIds.length;
  }

  getAgentCountBySelectedStatus() {
    return this.totals[_.camelCase(this.filtersConfig.agentsStatus) || 'total'];
  }

  onApplyPreferencesChanges(preferences) {
    const text = 'Are you sure you want to apply these changes?';
    const extraText = this.filtersConfig.queryString ? '' : 'X_AGENTS_BULK_EDIT_INFO';
    const count = this.getSelectedAgentsCount();

    this.confirmDialogService.confirmWithInfo('Bulk Edit', text, extraText, {x: count}, event)
      .then(() => {
        this._applyPreferencesChanges(preferences);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      });
  }

  onSendNotificationToAgents(agentPnType: string, selectedAgentId?: string) {
    let selectedIds: string[];
    let excludedIds: string[];

    if (!!selectedAgentId) {
      selectedIds = [selectedAgentId];
      excludedIds = [];
    } else {
      selectedIds = this.excludeMode ? [] : this.selectedAgentIds;
      excludedIds = this.excludeMode ? this.selectedAgentIds : [];
    }

    this.agentsService.sendNotification(
      agentPnType,
      selectedIds,
      excludedIds,
      this.filtersConfig.bringozFilters.branchIds,
      this.filtersConfig.bringozFilters.noBranches,
      this.filtersConfig.agentsStatus,
      this.filtersConfig.bringozFilters.agentType,
      this.filtersConfig.bringozFilters.agentSkills,
      this.filtersConfig.bringozFilters.gpsStatus,
      this.filtersConfig.bringozFilters.gpsPermissions,
      this.filtersConfig.bringozFilters.isActive,
      this.filtersConfig.bringozFilters.sessionRecording,
      this.filtersConfig.bringozFilters.noArea,
      this.filtersConfig.bringozFilters.serviceAreaIds
    );
  }

  onManageAssistants(agent, $event) {
    this.agentDialogService.manageAssistants(agent, $event)
      .then((updatedAssistants) => {
        const agentCopy = angular.copy(agent);
        agentCopy.assistantAgentIds = updatedAssistants;
        this._updateAgentAssistants(agentCopy);
      })
  }

  onRemoveFromAssistantMode(agent, $event) {
    const assistantFullName = `${agent.user.firstName} ${agent.user.lastName}`;

    const header = `${this.$filter<any>('translate')('Remove')} ${assistantFullName} ${this.$filter<any>('translate')('from Assistant mode')}`
    const body = `${assistantFullName} ${this.$filter<any>('translate')('will no longer be driver assistant to agent')} ${agent.agentReferences[0].fullName}`;
    this.confirmDialogService.confirm(header, body, event)
      .then(() => {
        this.removeAgentFromAssistantMode(agent.agentReferences[0].id, agent.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onPasswordLess(agent: AgentModel, authType: AgentAuthType, $event) {
    const client = agent.agentType === AgentType.Driver ? AgentClientType.Driver : AgentClientType.Workforce;
    this.agentsService.passwordless(agent.id, authType, client)
      .then((res) => {

      })
  }

  camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getDefaultStatus() {

    if (this.$stateParams.status && this.agentStatus.statuses[this.$stateParams.status]) {
      return this.$stateParams.status;
    }
    return undefined;
  }

  private _setAgentsPreferences(isEnabled) {
    this.agentsPreferences = isEnabled ? {
      status: undefined,
      appAccess: undefined,
      userFeatures: {
        countryCode: undefined,
        localeCode: undefined,
      },
      displayWarningMessages: undefined,
      applicationFeatures: {
        market: undefined,
        billing: undefined,
        selfAssign: undefined,
        auctions: undefined,
        scanToPair: undefined,
        validateProOnScan: undefined,
        displaySchedule: undefined,
        barcode: undefined,
        missingItem: undefined,
        loadingOrder: undefined,
        itineraryInfo: undefined,
        noItemValidation: undefined,
        allowCancel: undefined,
        allowContactNotAvailable: undefined,
        disableContactNotAvailableLock: undefined,
        countMileage: undefined,
        scanBarcode: undefined,
        displayAdditionalInfo: undefined,
        noPackageValidation: undefined,
        createOrder: undefined,
        onDutyBasedOnServiceArea: undefined,
        onDutyBasedOnShift: undefined,
        geofencingEnabled: undefined,
        allowAddAdditions: undefined,
        allowAddExpense: undefined,
        blockDepartedBeforeTimeWindow: undefined,
        offline: undefined,
        branchSummaryPortal: undefined,
        branchSummaryApp: undefined
      },
      agentPreferences: {
        geofencingBlockArrivalOutOfRange: undefined,
        geofencingBlockDepartureOutOfRange: undefined,
        geofencingBlockAbortOutOfRange: undefined,
        geofencingPickupEnabled: undefined,
        geofencingDropoffEnabled: undefined,
        completeAndHeadingOption: undefined,
        autoBackFromBreak: undefined,
        ignoreForceUpdate: undefined,
        breakDurationMinutes: undefined,
        backFromBreakReminderGapMinutes: undefined,
        forcePairing: undefined,
        forceValidation: undefined,
        displayWarningMessages: undefined,
        forceGps: undefined,
        clickToScan: undefined,
        quickValidation: undefined,
        distanceValidationRadius: undefined,
        geofencingAbortTaskRadius: undefined,
        geofencingArrivalTaskRadius: undefined,
        geofencingDepartureTaskRadius: undefined,
        quantityValidation: undefined,
        forceDropOffsOfStartedServicesBeforePickups: undefined
      }
    } : undefined
  }

  private _updateAgentAssistants(agent: AgentModel) {
    this.agentsService.updateAgentAssistants(agent)
      .then((updatedAgent) => {

      })
  }

  private removeAgentFromAssistantMode(primaryAgentId, agentAssistantId) {
    this.$agent(primaryAgentId).$asyncValue()
      .then((primaryAgent) => {
        primaryAgent.assistantAgentIds = _.filter(primaryAgent.assistantAgentIds, (aid) => {
          return agentAssistantId !== aid;
        });
        this._updateAgentAssistants(primaryAgent);
      })
  }

  private _setStateParams() {
    this.$state.go('.', {
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      groupIds: this.filtersConfig.bringozFilters.groupIds,
      serviceAreaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      tags: this.filtersConfig.bringozFilters.tags,
      agentSkills: this.filtersConfig.bringozFilters.agentSkills,
      isActive: this.filtersConfig.bringozFilters.isActive,
      sessionRecording: this.filtersConfig.bringozFilters.sessionRecording,
      termsApproved: this.filtersConfig.bringozFilters.termsApproved,
      noArea: this.filtersConfig.bringozFilters.noArea,
      noBranches: this.filtersConfig.bringozFilters.noBranches,
      gpsStatus: this.filtersConfig.bringozFilters.gpsStatus,
      gpsPermissions: this.filtersConfig.bringozFilters.gpsPermissions,
      agentType: this.filtersConfig.bringozFilters.agentType,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      teamIds: this.filtersConfig.bringozFilters.teamIds,
    }, {notify: false, reload: false, location: 'replace'});
  }

  private _updateViewTableSettings(columns: {}) {
    const settings = {};

    for (const key in columns) {
      settings[key] = columns[key].enabled ? 1 : 0;
    }

    if (this.viewTableSettings) {
      const viewTableSettingsCopy = {...this.viewTableSettings, settings: settings}
      this.viewSettingsService.updateByUser(this.viewTableSettings.id, viewTableSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.viewTableSettings = viewSettingsTable
        })

    } else {
      const viewTableSettings: ViewSettingsModel = {
        pageName: this.pageName,
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.ViewTable,
        settings: settings
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.viewTableSettings = viewSettingsTable
        })
    }

  }

  private _export(exportType: ExportType) {
    this.agentsService.exportAgents(
      exportType,
      this.filtersConfig.agentsStatus,
      this.filtersConfig.bringozFilters.agentType,
      this.filtersConfig.bringozFilters.branchIds,
      this.filtersConfig.bringozFilters.noBranches,
      this.filtersConfig.bringozFilters.isActive,
      this.filtersConfig.bringozFilters.sessionRecording,
      this.filtersConfig.bringozFilters.serviceAreaIds,
      this.filtersConfig.bringozFilters.gpsStatus,
      this.filtersConfig.bringozFilters.gpsPermissions
    );
  }

  private _applyPreferencesChanges(preferences) {
    let selectedIds;
    let excludedIds = this.excludeMode ? this.selectedAgentIds : [];

    if (this.filtersConfig.bringozFilters.agentIds?.length) {
      selectedIds = this.excludeMode ? this.filtersConfig.bringozFilters.agentIds : this.selectedAgentIds;
    } else {
      selectedIds = this.excludeMode ? [] : this.selectedAgentIds;
    }

    const query: BulkPreferencesUpdateQuery = {
      ids: selectedIds,
      excludedIds: excludedIds,
      query: this.filtersConfig.queryString,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      tags: this.filtersConfig.bringozFilters.tags,
      areaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      noBranches: this.filtersConfig.bringozFilters.noBranches,
      noArea: this.filtersConfig.bringozFilters.noArea,
      active: this.filtersConfig.bringozFilters.isActive,
      sessionRecording: this.filtersConfig.bringozFilters.sessionRecording,
      termsApproved: this.filtersConfig.bringozFilters.termsApproved,
      status: this.filtersConfig.agentsStatus,
      agentTypes: this.filtersConfig.bringozFilters.agentType,
      skill: this.filtersConfig.bringozFilters.agentSkills,
      gpsStatus: this.filtersConfig.bringozFilters.gpsStatus,
      gpsPermission: this.filtersConfig.bringozFilters.gpsPermissions
    }

    this.agentsService.bulkPreferencesUpdate(preferences, query)
      .then((res) => {
        this._setAgentsPreferences(false);
        this.selectedAgentIds = [];
        this.excludeMode = false;
      })
      .catch((error) => {
        this.$log.error('Failed to bulk update agents preferences', error)
      })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsListView', {
    bindings: {
      serviceAreaIds: '<?',
      tags: '<?',
      branchIds: '<?',
      groupIds: '<?',
      groupsBranchIds: '<',
      isActive: '<?',
      sessionRecording: '<?',
      termsApproved: '<?',
      agentSkills: '<?',
      noArea: '<?',
      noBranches: '<?',
      gpsStatus: '<?',
      gpsPermissions: '<?',
      agentType: '<?',
      viewTableSettings: '<?',
      selectedQuickFilterId: '<?',
      teamIds: '<?',
      agentIds: '<?'
    },
    template: require('./agents-list-view.html').default,
    controller: AgentsListViewCtrl
  });
